// constant variables for form announcement.
export const EVERY_ONE = {
  name: "Everyone",
  id: "every_one",
};

export const DEVICES = {
  id: "device",
  name: "Select Devices",
};

export const POLICY_GROUP = { id: "policy_group", name: "Select Device Groups" };

export const FormAnnouncementsList = [EVERY_ONE, POLICY_GROUP, DEVICES];

export const languages = [
  {
    value: "",
    key: "Select a language",
  },
  {
    value: "af",
    key: "Afrikaans",
  },
  {
    value: "ar",
    key: "العربية",
  },
  {
    value: "hy",
    key: "Հայերեն",
  },
  {
    value: "az",
    key: "Azərbaycan",
  },
  {
    value: "be",
    key: "Беларуская",
  },
  {
    value: "bs",
    key: "Bosanski",
  },
  {
    value: "bg",
    key: "Български",
  },
  {
    value: "ca",
    key: "Català",
  },
  {
    value: "zh",
    key: "中文",
  },
  {
    value: "hr",
    key: "Hrvatski",
  },
  {
    value: "cs",
    key: "Čeština",
  },
  {
    value: "da",
    key: "Dansk",
  },
  {
    value: "nl",
    key: "Nederlands",
  },
  {
    value: "en",
    key: "English",
  },
  {
    value: "et",
    key: "Eesti",
  },
  {
    value: "fi",
    key: "Suomi",
  },
  {
    value: "fr",
    key: "Français",
  },
  {
    value: "gl",
    key: "Galego",
  },
  {
    value: "de",
    key: "Deutsch",
  },
  {
    value: "el",
    key: "Ελληνικά",
  },
  {
    value: "he",
    key: "עברית",
  },
  {
    value: "hi",
    key: "हिन्दी",
  },
  {
    value: "hu",
    key: "Magyar",
  },
  {
    value: "is",
    key: "Íslenska",
  },
  {
    value: "id",
    key: "Bahasa Indonesia",
  },
  {
    value: "it",
    key: "Italiano",
  },
  {
    value: "ja",
    key: "日本語",
  },
  {
    value: "kn",
    key: "ಕನ್ನಡ",
  },
  {
    value: "kk",
    key: "Қазақ",
  },
  {
    value: "ko",
    key: "한국어",
  },
  {
    value: "lv",
    key: "Latviešu",
  },
  {
    value: "lt",
    key: "Lietuvių",
  },
  {
    value: "mk",
    key: "Македонски",
  },
  {
    value: "ms",
    key: "Bahasa Melayu",
  },
  {
    value: "mr",
    key: "मराठी",
  },
  {
    value: "mi",
    key: "Māori",
  },
  {
    value: "ne",
    key: "नेपाली",
  },
  {
    value: "nb",
    key: "Norsk",
  },
  {
    value: "fa",
    key: "فارسی",
  },
  {
    value: "pl",
    key: "Polski",
  },
  {
    value: "pt",
    key: "Português",
  },
  {
    value: "ro",
    key: "Română",
  },
  {
    value: "ru",
    key: "Русский",
  },
  {
    value: "sr",
    key: "Српски",
  },
  {
    value: "sk",
    key: "Slovenčina",
  },
  {
    value: "sl",
    key: "Slovenščina",
  },
  {
    value: "es",
    key: "Español",
  },
  {
    value: "sw",
    key: "Kiswahili",
  },
  {
    value: "sv",
    key: "Svenska",
  },
  {
    value: "tl",
    key: "Tagalog",
  },
  {
    value: "ta",
    key: "தமிழ்",
  },
  {
    value: "th",
    key: "ไทย",
  },
  {
    value: "tr",
    key: "Türkçe",
  },
  {
    value: "uk",
    key: "Українська",
  },
  {
    value: "ur",
    key: "اردو",
  },
  {
    value: "vi",
    key: "Tiếng Việt",
  },
  {
    value: "cy",
    key: "Cymraeg",
  },
];

export const translateBehavior = [
  {
    value: "",
    key: "Select a translate behavior",
  },
  {
    value: "alwaysTranslate",
    key: "Always translate",
  },
  {
    value: "neverTranslate",
    key: "Never translate",
  },
  {
    value: "askEachTime",
    key: "Ask each time",
  },
];
